import {
  AnalysisItem,
  GroupRowType,
  GroupTableType,
  LegendItem,
  LocationItem
} from "helpers/models";
import getColor from "./color-event";

export default (
  groupData: Record<string, AnalysisItem[]>,
  locationItems: LocationItem[],
  eventLegend: LegendItem,
  aggregationUnits: string[]
): GroupRowType[] => {
  const locationMap = Object.fromEntries(
    locationItems.map((item: LocationItem) => [item.id.replaceAll('-', ''), item])
  );

  const detailTable: any[] = [];
  Object.entries(groupData).forEach(
    ([label, items]) => {
      const row: Record<string, any> = {
        label: label,
        // [e]: sum,
        count: items.length,
        color: getColor(label, eventLegend)
      };

      aggregationUnits
        .filter((e) => e !== "numberOfLocations")
        .forEach((e) => {
          const sum = items.reduce((acc, i) => {
            if (i.pointId) {
              const locationItem = locationMap[i.pointId.replaceAll('-', '')];
              if (!locationItem) {
                return 0;
              }
              const agg = locationItem[e as keyof LocationItem];
              if (typeof agg === "number") {
                return acc + agg;
              }
            }
            return acc;
          }, 0);

          if (sum > 0) {
            row[e] = sum;
          }
        });

      detailTable.push(row);

      // if (detailTable && detailTable.length > 0) {
      //   acc[layerId] = detailTable;
      // }
      // return acc;
    },

    {} as GroupTableType
  );

  return detailTable;
};
